import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  isRescheduleClassesFilterModalOpenSelector,
  setRescheduleClassesFilterModalState,
} from 'features/classCreation';
import HideBodyScroll from 'components/HideBodyScroll';
import RescheduleClassesFilterDrawerContent from '../RescheduleClassesFilterDrawerContent';
import styles from './RescheduleClassesFilterDrawer.module.scss';

function RescheduleClassesFilterDrawer() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(isRescheduleClassesFilterModalOpenSelector);

  const handleModalClose = useCallback(() => {
    dispatch(setRescheduleClassesFilterModalState(false));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleModalClose}
      position="right"
      unMountOnClose
      withoutHeader
      className={styles.root}
      containerClassName={styles.containerClassName}
      hasCloseButton={false}
      size="large"
    >
      <RescheduleClassesFilterDrawerContent />
      {isModalOpen && <HideBodyScroll />}
    </Modal>
  );
}

export default RescheduleClassesFilterDrawer;
